import React from 'react';

const ProductTabsDescr = () => {
    return (
        <div className={'product__tabs-descr'}>
            <h2 className={'product__tabs-descr-title'}>Описание</h2>
            <p className={'product__tabs-descr-subtitle'}>НИЧЕГО ЛИШНЕГО. ТОЛЬКО САМОЕ!</p>
            <p className={'product__tabs-descr-text'}>
                Новая система двух камер не оставит никого из ваших друзей за кадром. Самый быстрый процессор iPhone и мощный аккумулятор позволят больше делать и тратить меньше времени на подзарядку. А высочайшее качество видео на iPhone означает, что ваши истории станут еще ярче и детальнее.
            </p>
            <p className={'product__tabs-descr-subtitle'}>ПЛОХОЕ ФОТО? НЕ ВЫЙДЕТ</p>
            <p className={'product__tabs-descr-text'}>
                Новая система двух камер. Можно делать фотоснимки с широким и сверхшироким углом обзора. Обновленный интерфейс и новая сверхширокоугольная камера позволят увидеть и снять то, что происходит за пределами кадра. Снимать и редактировать видеоролики теперь так же легко, как фотографии. Это по-прежнему невероятно популярная камера, но с совершенно новыми перспективами.
            </p>
        </div>
    );
};

export default ProductTabsDescr;